import React from 'react';
import './HeaderProfile.css';
const HeaderProfile = ({email}) => {
  return (
    <div className='header-profile'>
      <div className='header-profile__container'>
        <div className='header-profile__wrapper-title'>
          <span className='header-profile__title-email'>{email}</span>
        </div>
      </div>
    </div>
  );
};

export default HeaderProfile;
